module.exports = "//static.hsappstatic.net/salesImages/static-1.403/sales-content/templates-meetings-cta-banner2.png"